import { requestHelpers } from '../../helpers';

const actions = {
    GET_SECTORS: "GET_SECTORS",
    SET_SECTORS: "SET_SECTORS",
};

// function getSectors() {
//     return ( dispatch ) => {
//         dispatch( {
//             type: actions.GET_SECTORS,
//         } );
//
//         requestHelpers
//             .authenticatedGetRequest( '/common/sectors' )
//             .then( ( response ) => {
//                 dispatch( {
//                     type: actions.SET_SECTORS,
//                     sectors: response.data,
//                 } );
//             } );
//     };
// }

function getSectors() {
    return ( dispatch ) => {
        dispatch( {
            type: actions.GET_SECTORS,
        } );

        requestHelpers
            .authenticatedGetRequest( '/common/job/sectors' )
            .then( ( response ) => {

                const siteOfOrigin = localStorage.getItem( 'site_of_origin' );

                // console.log( "US", response.data.us );
                // console.log( "UK", response.data.uk );

                dispatch( {
                    type: actions.SET_SECTORS,
                    sectors: siteOfOrigin === 'us' ? response.data.us : response.data.uk,
                } );
            } );
    };
}

module.exports = {
    actions,
    getSectors
}


// WEBPACK FOOTER //
// src/client/actions/common/sectors.js